var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipeCoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.048,
    height: 20.415,
    viewBox: "0 0 15.048 20.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fecf45;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #1228f3;\n      }\n\n      .cls-2 {\n        fill: #fef500;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cion_for_pipe",
    "data-name": "cion for pipe",
    transform: "translate(-505.811 -1191.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99228",
    "data-name": "Path 99228",
    className: "cls-1",
    d: "M5.87-.127c.2,0,2.076.013,2.583.09,3,.385,4.561,4.551,4.561,9.468,0,4.026-1.231,7.777-3.959,9.273-.441.254-2.369.03-3.184.03-3.594,0-5.87-4.095-5.87-9.3S2.276-.127,5.87-.127Z",
    transform: "translate(520.338 1210.875) rotate(178)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1650",
    "data-name": "Ellipse 1650",
    className: "cls-2",
    cx: 4.925,
    cy: 9.431,
    rx: 4.925,
    ry: 9.431,
    transform: "translate(516.83 1210.998) rotate(178)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeCoin);
export default __webpack_public_path__ + "static/media/pipe-coin.f6e7e355011a4f44da97b839c3460ddc.svg";
export { ForwardRef as ReactComponent };